import React from "react";
import { useObservationSchoolAdminManager } from "../../../hooks/useManagers";
import ObservationMgmt from "./ObservationMgmt";

const ObservationSchoolAdminMgmt = () => {
  var observationMgr = useObservationSchoolAdminManager();
  return <ObservationMgmt isTeacher={false} observationMgr={observationMgr} />;
};

export default ObservationSchoolAdminMgmt;
